export const WS_ERROR_CODES = {
  CONNECTION_CLOSED: 11,
} as const;
